import React from 'react';
import { DMRVPageTemplate } from '../components/dmrv/DMRVPageTemplate';
export function Agroforestry() {
  return <DMRVPageTemplate id="agroforestry" tagline="Agroforestry & Soil Carbon | Uganda" headline="Measuring Carbon Sequestration in Agricultural Landscapes" highlightWord="Carbon Sequestration" description="Uganda's 7M+ hectares of agricultural land hold enormous potential for carbon removal through agroforestry, cover cropping, and regenerative practices. CarbonSafe quantifies and verifies every ton sequestered." badges={['Verra VCS', 'Gold Standard', 'ISO 14064']} heroEmoji="🌾" floatingIcons={[{
    emoji: '🌱',
    position: 'top'
  }, {
    emoji: '🧪',
    position: 'right'
  }, {
    emoji: '🗺️',
    position: 'left'
  }]} statsHeadline="The soil carbon opportunity" statsSubtext="Agricultural soils are one of the largest untapped carbon sinks in East Africa." stats={[{
    value: '7M+',
    label: 'Hectares Available',
    detail: 'Agricultural land in Uganda suitable for agroforestry and soil carbon projects'
  }, {
    value: '2.5',
    label: 'Tons CO₂/ha/year',
    detail: 'Average carbon sequestration potential from agroforestry practices in tropical soils'
  }, {
    value: '68%',
    label: 'Smallholder Farms',
    detail: "Of Uganda's agriculture is smallholder, requiring scalable, low-cost MRV solutions"
  }, {
    value: '$80M+',
    label: 'Annual Potential',
    detail: 'Estimated carbon credit revenue from soil carbon and agroforestry in Uganda'
  }]} howItWorksVerticalName="agroforestry" howItWorksSubtext="From farm enrollment to credit issuance, four steps to verified soil carbon." howItWorksSteps={[{
    icon: 'UsersIcon',
    title: 'Farmer Enrollment',
    description: 'Mobile-first registration captures farm boundaries, soil baselines, and current practices.'
  }, {
    icon: 'DropletIcon',
    title: 'Soil & Practice Monitoring',
    description: 'GPS-tagged soil sampling and digital verification of regenerative farming practices.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Carbon Modeling',
    description: 'IPCC Tier 2/3 models calibrated for East African soils calculate sequestration rates.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Credit Issuance',
    description: 'Verra or Gold Standard verified credits with 20-year permanence monitoring.'
  }]} impactImageUrl="https://cropwatch.unl.edu/sites/unl.edu.ianr.extension.cropwatch/files/styles/16_9_505x284/public/media/image/2024-12-06-soil-health-technologies-hero.jpg?itok=XbIv24wV" impactImageAlt="Soil health monitoring technology being used in agricultural fields" impactTagline="Technology in the Field" impactHeadline="Modern soil science meets smallholder farming" impactDescription="CarbonSafe combines field-portable sensors, standardized sampling, and AI modeling to make soil carbon verification affordable and scalable across Uganda's diverse farmlands." impactCtaText="Explore Soil Carbon Solutions" featuresHeadline="Why soil carbon MRV is" featuresHighlight="uniquely challenging" featuresSubtext="Soil carbon measurement requires precision, consistency, and long-term monitoring that traditional methods struggle to deliver." features={[{
    icon: 'DropletIcon',
    title: 'Soil Sampling',
    description: 'Standardized sampling protocols with GPS-tagged collection points, lab analysis integration, and digital chain-of-custody tracking.'
  }, {
    icon: 'LeafIcon',
    title: 'Biomass Measurement',
    description: 'Above-ground and root biomass quantification for shade trees, cover crops, and intercropped species using allometric equations.'
  }, {
    icon: 'SunIcon',
    title: 'Practice Verification',
    description: 'Digital monitoring of farming practices like mulching, composting, and reduced tillage, with photo evidence and farmer attestation.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Carbon Modeling',
    description: 'IPCC Tier 2/3 soil carbon models calibrated for East African soil types, rainfall patterns, and cropping systems.'
  }, {
    icon: 'UsersIcon',
    title: 'Farmer Enrollment',
    description: 'Scalable digital onboarding for smallholders with mobile-first registration, training modules, and payment tracking.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Permanence Guarantee',
    description: '20-year monitoring commitments with buffer pools, practice reversal detection, and automated crediting adjustments.'
  }]} ctaHeadline="Every hectare matters." ctaHighlight="Measure what grows beneath." ctaSubtext="Join agricultural organizations using CarbonSafe to unlock carbon revenue from Uganda's farmlands." ctaButtonText="Start Your Soil Carbon Project" platformPreview={{
    headline: 'Soil carbon verification in',
    highlightWord: 'one dashboard',
    subtext: 'Monitor farmer enrollment, soil sampling results, and carbon credit generation across all project sites.',
    urlPath: 'agroforestry',
    projectName: 'Eastern Uganda Soil Carbon Program',
    statusLabel: 'Active',
    sidebarItems: [{
      icon: 'Dashboard',
      label: 'Dashboard',
      active: true
    }, {
      icon: 'Farmers',
      label: 'Farmers'
    }, {
      icon: 'Soil Data',
      label: 'Soil Data'
    }, {
      icon: 'Practices',
      label: 'Practices'
    }, {
      icon: 'Reports',
      label: 'Reports'
    }, {
      icon: 'Settings',
      label: 'Settings'
    }],
    stats: [{
      label: 'Enrolled Farms',
      value: '4,280'
    }, {
      label: 'Soil Samples',
      value: '1,847',
      highlight: true
    }, {
      label: 'tCO₂e Sequestered',
      value: '8,420'
    }, {
      label: 'Credits Value',
      value: '$168K'
    }],
    chartLabel: 'Monthly Soil Samples Collected',
    activityItems: [{
      icon: 'UsersIcon',
      iconColor: 'text-carbon-bright',
      label: 'Farm #4280 enrolled',
      detail: 'Mbale district, 2.4 ha',
      time: '8m ago'
    }, {
      icon: 'CheckCircle2Icon',
      iconColor: 'text-emerald-500',
      label: 'Soil sample batch verified',
      detail: 'Batch #92, 24 samples',
      time: '1h ago'
    }, {
      icon: 'LeafIcon',
      iconColor: 'text-blue-500',
      label: 'Practice audit complete',
      detail: 'Cover cropping verified',
      time: '3h ago'
    }]
  }} data-id="element-1195" />;
}